import React, { useEffect, useState } from "react";
import { collection, query, onSnapshot} from "firebase/firestore";
import { db } from "../firebase";
import { Link } from "react-router-dom";

const ShowingSLC = () => {
  const [list, setList] = useState([]);

  useEffect(() => {
    const q = query(collection(db, "leavingCertificate"));
    onSnapshot(q, (querySnapshot) => {
      let transferArray = [];
      querySnapshot.forEach((doc) => {
        transferArray.push({id:doc.id,...doc.data()});
      });
      setList(transferArray);
    });
  }, []);
  return (
    <div className="p-5  min-h-screen">
    <h1 className="text-left mb-4 ml-2 text-3xl font-semibold">
    All students School Leaving Certificate
    </h1>
    <table className="w-full  text-center">
      <thead className="border-b  ">
        <tr className="bg-gray-100">
          <th className="py-3 "> Sl No.</th>
          <th className="py-3 "> Admission No.</th>
          <th className="py-3 "> First Name</th>
          <th className="py-3 "> Last Name</th>
          <th className="py-3 "> Father's Name</th>
          <th className="py-3 "> View All</th>
        </tr>
      </thead>
      <tbody>
        {list?.map((item, index) => (
          <tr className="border-b" key={index}>
            <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
              {++index}
            </td>

            <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
              {item.admissionNo}
            </td>
            <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
              {item.pupilFirstName}
            </td>
            <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
              {item.pupilLastName}
            </td>
            <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
              {item.gaurdianFirstName}
            </td>
            <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
              <Link to={"../downloadTC"} state={{leavingId:item.id}}><div className="text-white bg-yellow-600 py-1 px-1 rounded-md">View all</div></Link>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div> 
  )
}

export default ShowingSLC